import { Box, CircularProgress, Table, TableBody, TableContainer, TableRow } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { AttioSortDirection } from 'dashboard409a/common/constants/analyst-dashboard';
import { StyledTableCellEmptyMessage } from 'dashboard409a/components/ValuationsTable/common';
import { modelsColumns } from 'dashboard409a/pages/Workboard/common/modelsColConfig';
import { ModelsTableHeadColumn } from './ModelsTable.types';
import ModelsTableHead from './ModelsTableHead/ModelsTableHead';
import ModelsTableRow from './ModelsTableRow/ModelsTableRow';
import { ModelWithValuationData } from '../../services/models.types';
import { handleModelRowClick } from '../../utilities/navigation';

interface ModelsTableProps {
  isLoading: boolean;
  rows: ModelWithValuationData[];
  onNoteSave: (fulfillmentId: number, noteContent: string, currentNote?: string) => Promise<void>;
  onStatusUpdate: (modelId: number, newStatus: number) => void;
  orderBy: string;
  order: AttioSortDirection;
  onRequestSort: (event: React.MouseEvent<unknown>, property: string) => void;
  isNoteLoading?: boolean;
  noteError?: string | null;
}

export const ModelsTable = ({
  isLoading,
  rows,
  onNoteSave,
  onStatusUpdate,
  orderBy,
  order,
  onRequestSort,
  isNoteLoading = false,
  noteError = null,
}: ModelsTableProps) => {
  const statusOptions: unknown[] = [];
  const statusOptionsLoading = false;
  const navigate = useNavigate();
  const handleRowClick = (model: ModelWithValuationData, event: React.MouseEvent<HTMLTableRowElement>) => {
    handleModelRowClick(model, event, navigate);
  };
  
  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <TableContainer>
      <Table>
        <ModelsTableHead
          orderBy={orderBy}
          order={order}
          onRequestSort={onRequestSort}
          columns={modelsColumns as ModelsTableHeadColumn[]}
        />
        <TableBody>
          {rows.length === 0 ? (
            <TableRow style={{ height: 33 }}>
              <StyledTableCellEmptyMessage colSpan={8}>No models found</StyledTableCellEmptyMessage>
            </TableRow>
          ) : (
            rows.map(row => (
              <ModelsTableRow
                key={row.id}
                modelRow={row}
                onRowClick={handleRowClick}
                statusOptions={statusOptions}
                statusOptionsLoading={statusOptionsLoading}
                onNoteSave={(noteContent, currentNote) => {
                  if (!row.id) {
                    return Promise.reject(new Error('Fulfillment ID is missing'));
                  }
                  // Pass the note content from the new structure or fallback to old structure
                  const currentNoteContent = row.note?.content || row.notes || '';
                  return onNoteSave(row.id, noteContent, currentNoteContent);
                }}
                onStatusUpdate={onStatusUpdate}
                isNoteLoading={isNoteLoading}
                noteError={noteError}
              />
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
